import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index'

Vue.use(VueRouter)

export const constantRouterMap = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录' },
    component: () => import('@/views/Login')
  },
  {
    path: '/404',
    component: () => import('@/views/Features/404'),
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/Features/redirect')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/certify',
    children: [
      {
        path: 'certify',
        name: 'Certify',
        meta: { title: '实名认证', icon: 'index', affix: true, noCache: true },
        component: () => import('@/views/Certify'),
      },
      {
        path: '/result',
        name: 'Result',
        meta: { title: '认证结果' },
        component: () => import('@/views/Result')
      },
    ]
  },
  {
    path: "*",
    component: () => import('@/views/Features/404')
  },
]

export default new VueRouter({
  // mode: 'hash',
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
